import React from 'react';
import ReactPlayer from 'react-player';
import VideoInfo from './VideoInfo';
import './styles.css';

const VideoPlayer = React.forwardRef(({ url, onClose, ...restProps }, ref) => {
  return (
    <VideoInfo onClose={onClose} title={restProps.title} isPlaying={restProps.playing} playerRef={ref}>
      <ReactPlayer
        ref={ref}
        url={url || ''}
        width={'100vw'} height={'100vh'}
        className='react-player'
        controls
        config={{
          file : {attributes : {
            controllist: 'nodownload noremoteplayback noplaybackrate',
          }}
        }}
        {...restProps}
      />
    </VideoInfo>
  );
});

export default VideoPlayer;